/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Made by Mateusz Janeczek
 * Contribution: Krzysiek Gregorowicz
 */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import styles from './TrapezoidMenu.scss';
import TabTrapezoid from './TabTrapezoid';
import ContentModal from './ContentModal';
import layerImg from './layers.png';
import { connect } from 'react-redux';

const sidebarStyles = {
  fontFamily: 'Roboto, sans-serif !important',
  position: 'absolute',
  top: '180px',
  right: '-360px',
};

const map_compositions = {
  OGÓLNY: ['mpzp'],
  TURYSTA: ['mpzp', 'decyzje śu', 'decyzje wz i ulicp', 'suikzp', 'emuia'],
  INWESTOR: ['komunikacja publiczna', 'poi i punkty turystyczne', 'punkty noclegowe', 'warstwy', 'ortofotomapa'],
  CMENTARZE: ['cmentarze', 'cmentarze_groby', 'cmentarze_sektory'],
  INNE: [],
};

class TrapezoidMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayModal: 1,
      showModal: false,
      sideDescription: this.props.sideDescription
    };
  }

  onClickTab = key => {
    if (this.state.showModal === false) {
      this.setState({ displayModal: key, showModal: true });
    } else if (this.state.showModal === true && this.state.displayModal === key) {
      this.setState({ showModal: false });
    } else {
      this.setState({ displayModal: key });
    }
  };

  getAllTab = () => {
    const tabs_by_compositions = {};
    
    this.props.district.compositions.forEach(e => {
      let key = e.composition_type;
      if (key){  // exclude null
        if (Object.keys(tabs_by_compositions).indexOf(key) === -1) {
          tabs_by_compositions[key] = []
        };
        tabs_by_compositions[key].push(e.nazwa);
      }
    });

    return tabs_by_compositions;
  };

  renderTabs = () => {
    const allTabs = this.getAllTab();
    return (
      <div className="rightSidebar-tabs">
        {Object.keys(allTabs).map(
          (v, i) =>
            allTabs[v].length > 0 ? (
              <TabTrapezoid
                key={i}
                tabKey={i}
                onClickTab={key => this.onClickTab(key)}
                displayModal={this.state.displayModal}
                showModal={this.state.showModal}
                title={v}
              />
            ) : null,
        )}
      </div>
    );
  };

  // this.props.prefix != 'krosno' ? 'Ogólny' : warstwy

  render() {
    const allTabs = this.getAllTab();
    const sidebarShow =
      this.state.showModal === false ? 'rightSidebar-cont' : 'rightSidebar-cont showSidebar';
    const mobileModal =
      this.state.showModal === false ? 'rightSidebar-content' : 'rightSidebar-content showUp';
    const layerIconLight = this.state.displayModal === 0 ? 'lightOff' : (this.props.sideDescription.contentType == 'cmentarze' ? 'lightOn-cmentarze' : 'lightOn');

    if (this.props.areCompositionsBeingFetched) {
      return (
        <div style={sidebarStyles} className={sidebarShow}>
          <div className="rightSidebar-tabs">
            <h3 className="rightSidebar-button-text">Pobieranie kompozycji</h3>
          </div>
        </div>
      );
    } else if (
      this.props.areCompositionsFetched &&
      this.props.district &&
      this.props.district.compositions
    ) {
      return (
        <div style={sidebarStyles} className={sidebarShow}>
          <div className="rightSidebar-nav">
            <div className="rightSidebar-icon perfectCenter">
              <img className={layerIconLight} src={layerImg} />
            </div>
            {this.renderTabs()}
          </div>
          <div className={mobileModal}>
            {allTabs ? (
              <ContentModal
                displayModal={this.state.displayModal}
                compositions={
                  allTabs[
                    Object.keys(allTabs)[this.state.displayModal]
                  ]
                }
                composition_name={Object.keys(allTabs)[this.state.displayModal]}
                prefix={this.props.prefix}
              />
            ) : null}
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapState = state => ({
  intl: state.intl,
  district: state.district.district,
  areCompositionsFetched: state.district.areCompositionsFetched,
  areCompositionsBeingFetched: state.district.areCompositionsBeingFetched,
  sideDescription: state.district.sideDescription,
});

const mapDispatch = {};

TabTrapezoid.propTypes = {
  intl: PropTypes.object,
  prefix: PropTypes.string,
  district: PropTypes.shape({
    compositions: PropTypes.arrayOf(PropTypes.object),
  }),
  areCompositionsFetched: PropTypes.bool,
  areCompositionsBeingFetched: PropTypes.bool,
};

export default withStyles(styles)(
  connect(
    mapState,
    mapDispatch,
  )(TrapezoidMenu),
);



// WEBPACK FOOTER //
// src/components/TrapezoidMenu/TrapezoidMenu.js